/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Psychology15Inputs */

const en__field_enum_icsrm_psychology15 = /** @type {(inputs: _Field_Enum_Icsrm_Psychology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychology`)
};

const de__field_enum_icsrm_psychology15 = /** @type {(inputs: _Field_Enum_Icsrm_Psychology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychologie`)
};

/**
* | output |
* | --- |
* | "Psychology" |
*
* @param {_Field_Enum_Icsrm_Psychology15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_psychology15 = /** @type {((inputs?: _Field_Enum_Icsrm_Psychology15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Psychology15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_psychology15(inputs)
	return de__field_enum_icsrm_psychology15(inputs)
});
export { _field_enum_icsrm_psychology15 as "_field_enum_ICSRM_PSYCHOLOGY" }